export const hideCentralCharacters = (accountNumber: string, fromPosition: number, toPositionNegative: number) => {
  const length = accountNumber.length;
  return `${accountNumber.slice(0, fromPosition)}***${accountNumber.slice(length + toPositionNegative, length)}`;
};
